import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion, AnimatePresence } from 'framer-motion';
import { CreditCard, Wallet, TrendingUp, AlertOctagon, Activity, ChevronDown } from 'lucide-react';
export function Layer1DataIngestion() {
  const [expandedId, setExpandedId] = useState<number | null>(0);
  const signals = [{
    id: 0,
    title: 'Transaction History',
    icon: CreditCard,
    color: 'text-indigo-600',
    bg: 'bg-indigo-50',
    items: ['Daily and monthly Gross Merchandise Value (GMV)', 'Transaction count and frequency', 'Average ticket size per merchant', 'Peak vs trough trading days and seasonality patterns']
  }, {
    id: 1,
    title: 'Settlement Data',
    icon: Wallet,
    color: 'text-teal-600',
    bg: 'bg-teal-50',
    items: ['Net settlement amounts paid out (after fees and chargebacks)', 'Settlement timing and regularity', 'Days between settlement cycles']
  }, {
    id: 2,
    title: 'MDR Revenue Stream',
    icon: TrendingUp,
    color: 'text-blue-600',
    bg: 'bg-blue-50',
    items: ['Blended MDR rate per merchant', 'Absolute MDR revenue generated monthly', 'Trend in MDR revenue (proxy for processing volume trajectory)']
  }, {
    id: 3,
    title: 'Chargeback and Refund Data',
    icon: AlertOctagon,
    color: 'text-red-600',
    bg: 'bg-red-50',
    items: ['Dispute-to-transaction ratio (chargeback rate)', 'Refund-to-GMV ratio', 'Dispute trend — improving or deteriorating', 'Void and failed transaction rates']
  }, {
    id: 4,
    title: 'Operational Signals',
    icon: Activity,
    color: 'text-amber-600',
    bg: 'bg-amber-50',
    items: ['Active trading days per month (days with at least one settled transaction)', 'Customer transaction concentration (how many unique payers)', 'Settlement holds or account flags']
  }];
  return <SectionWrapper title="Layer 1: PSP Data Ingestion" subtitle="The PSP's core advantage over any external lender is ownership of live, ground-truth merchant revenue data. The following data categories are ingested and normalised before feature engineering begins." data-id="element-150">
      <div className="space-y-4" data-id="element-151">
        {signals.map(signal => {
        const Icon = signal.icon;
        const isExpanded = expandedId === signal.id;
        return <div key={signal.id} className={`bg-white rounded-xl border transition-colors duration-200 ${isExpanded ? 'border-indigo-200 shadow-md' : 'border-slate-200 shadow-sm hover:border-slate-300'}`} data-id="element-152">
              <button onClick={() => setExpandedId(isExpanded ? null : signal.id)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-153">
                <div className="flex items-center gap-4" data-id="element-154">
                  <div className={`p-2.5 rounded-lg ${signal.bg} ${signal.color}`} data-id="element-155">
                    <Icon className="w-5 h-5" data-id="element-156" />
                  </div>
                  <h3 className="font-semibold text-slate-900 text-lg" data-id="element-157">
                    {signal.title}
                  </h3>
                </div>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`} data-id="element-158" />
              </button>

              <AnimatePresence data-id="element-159">
                {isExpanded && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} className="overflow-hidden" data-id="element-160">
                    <div className="px-6 pb-6 pt-2 pl-[4.5rem]" data-id="element-161">
                      <ul className="space-y-3" data-id="element-162">
                        {signal.items.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-slate-600" data-id="element-163">
                            <div className="w-1.5 h-1.5 rounded-full bg-slate-300 mt-2 flex-shrink-0" data-id="element-164" />
                            <span className="leading-relaxed" data-id="element-165">{item}</span>
                          </li>)}
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </SectionWrapper>;
}